import { Component } from '@angular/core';

@Component({
  selector: 'app-wrapper',
  template: '<router-outlet></router-outlet>',
  styles: []
})
export class AppWrapperComponent {}